"use strict";

var TeamActions = require("app/screens/Team/actions/team-actions");
var SignalActions = require("app/shared/actions/signal-actions");
var teamsAPI = require("app/util/api/team");
var PromptList = require("app/shared/components/Prompt/prompt-list");

var ERROR_MESSAGE_TIME = 5000;

var RemoveTeamPrompt = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    team: React.PropTypes.object,
    isOpen: React.PropTypes.bool,
    onClose: React.PropTypes.func,
    onConfirmSuccess: React.PropTypes.func
  },
  handleConfirm: function() {
    TeamActions.deleteTeam(this.props.team, this.handleConfirmSuccess, this.handleConfirmError);
  },
  handleConfirmSuccess: function() {
    if (this.props.onConfirmSuccess) {
      this.props.onConfirmSuccess();
    }
    
    this.props.onClose();    
  },
  handleConfirmError: function(error, response) {
    var errorMessage = teamsAPI.getTeamErrorMessage(error, response);
    SignalActions.show({
      message: errorMessage,
      type: "warning",
      hideTimeout: ERROR_MESSAGE_TIME
    });
  },
  intlMessages: function() {
    var teamName = this.props.team ? this.props.team.name : "";
    var titleMessage = this.getIntlMessage("prompt.remove_team.title");
    var formattedTitleMessage = this.formatMessage(titleMessage, { teamName: teamName, });
    var textMessage = this.getIntlMessage("prompt.remove_team.text");
    var removeCheckboxMessage = this.getIntlMessage("prompt.remove_team.checkbox_item");

    return {
      title: formattedTitleMessage,
      text: textMessage,
      removeCheckbox: removeCheckboxMessage
    };
  },
  render: function(){
    var props = {
      title: this.intlMessages().title,
      text: this.intlMessages().text,
      hideWarningIcon:false,
      buttonText: "Confirmar",
      buttonClasses: "btn btn-danger",
      autoClose: false,
      isOpen: this.props.isOpen,
      checkboxItems: [{checked:false, text: this.intlMessages().removeCheckbox}],
      onConfirm: this.handleConfirm,
      onClose: this.props.onClose,
      type: "confirm"
    };
    return (
      <PromptList {...props} />
    );

  }
});

module.exports = RemoveTeamPrompt;



// WEBPACK FOOTER //
// ./app/shared/components/TeamSelector/remove-team-prompt.jsx